import * as React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, StatusIcon } from "components/common";
import PreviewInternalLakeLogsButton from "data-lake/components/PreviewInternalLakeLogsButton";
import PreviewExternalLakeLogsButton from "data-lake/components/PreviewExternalLakeLogsButton";
import useFeature from "hooks/useFeature";
import useStreamExternalDataLake from "data-lake/hooks/useStreamExternalDataLake";
import useStreamDataLakeEnabledStatus from "data-lake/hooks/useStreamDataLakeEnabledStatus";
const DataLakeCell = ({ stream }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const previewFeatureIsEnabled = useFeature("data_lake_search");
  const isEditable = stream.is_editable;
  const { dataLakeId: externalDataLakeId } = useStreamExternalDataLake(stream);
  const { data: enabled, isFetching: isFetchingInternal } = useStreamDataLakeEnabledStatus(stream.id, {
    enabled: isEditable
  });
  if (!isEditable) {
    if (!externalDataLakeId) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(PreviewExternalLakeLogsButton, { dataLakeId: externalDataLakeId });
  }
  if (isFetchingInternal) {
    return null;
  }
  const isDataLakeEnabled = enabled || false;
  if (previewFeatureIsEnabled && isDataLakeEnabled) {
    return /* @__PURE__ */ React.createElement(PreviewInternalLakeLogsButton, { streamId: stream.id });
  }
  if (!isDataLakeEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label: t("cell.enabled_tooltip") }, /* @__PURE__ */ React.createElement(StatusIcon, { active: true }));
};
export default DataLakeCell;
